import React from 'react';
var PrimaryLogoClearanceSVG = function PrimaryLogoClearanceSVG(_ref) {
    var width = _ref.width, svgClassName = _ref.svgClassName, clearanceClassName = _ref.clearanceClassName, specsClassName = _ref.specsClassName, specMarkersClassName = _ref.specMarkersClassName, logoClassName = _ref.logoClassName;
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 530 370",
        width: width,
        className: svgClassName
    }, /*#__PURE__*/ React.createElement("g", {
        className: clearanceClassName
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M527.02,310.24V51.43h-0.04V37.36H32.16V91.8h0.23v218.45h-0.27v54.44h495v-54.44H527.02z M102.66,104.57 h358.29v192.91H102.66V104.57z"
    })), /*#__PURE__*/ React.createElement("g", {
        className: logoClassName
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M197.89,246.23c-5.56,0-11.05,2.08-14.32,4.31l3.61,6.53c2.71-1.39,6.05-2.57,9.66-2.57 c4.24,0,6.6,2.15,6.6,5.35v2.36c-1.32-0.9-4.17-2.02-7.85-2.02c-8.48,0-14.11,4.86-14.11,12.02c0,7.64,6.25,12.16,13.62,12.16 c4.17,0,6.95-1.25,8.83-3.27l0.63,2.36h8.48v-23C213.04,252.34,209.57,246.23,197.89,246.23z M197.41,276.94 c-3.61,0-6.32-2.02-6.32-5c0-2.99,2.57-5.07,6.25-5.07s6.32,1.88,6.32,5.07C203.66,275,201.02,276.94,197.41,276.94z M222.21,283.48h9.59v-50.25h-9.59V283.48z M241.46,283.48h9.59v-36.35h-9.59V283.48z M158.49,246.23 c-10.35,0-17.79,8.2-17.79,19.18c0,10.91,7.44,18.97,19.11,18.97c9.03,0,13.9-5.42,15.29-7.99l-6.32-4.8 c-1.04,1.53-3.89,4.45-8.83,4.45c-5.35,0-9.24-3.47-9.45-8.34h25.57c0.07-0.7,0.07-1.39,0.07-2.08 C176.14,253.73,169.75,246.23,158.49,246.23z M150.78,261.45c0.42-4.17,3.34-7.37,7.85-7.37c4.38,0,7.58,2.92,7.78,7.37H150.78z M122.08,246.23c-4.73,0-8.06,2.64-9.59,5.14v-18.14h-9.59v50.25h9.59v-21.82c0-3.89,2.57-6.81,6.6-6.81c3.27,0,6.05,2.5,6.05,6.53 v22.1h9.52v-20.99C134.66,254.77,132.5,246.23,122.08,246.23z M364.11,246.23c-6.25,0-9.87,3.47-10.77,4.73v-17.72h-9.59v50.25 h9.03v-3.75c0.97,1.18,4.59,4.66,10.77,4.66c10.42,0,17.79-7.85,17.79-19.04C381.35,254.08,374.54,246.23,364.11,246.23z M362.38,275.9c-5.84,0-9.31-4.73-9.31-10.49c0-6.81,4.03-10.7,9.31-10.7c5.56,0,9.31,4.38,9.31,10.7 C371.69,271.87,367.8,275.9,362.38,275.9z M405.04,246.23c-11.05,0-19.53,8.13-19.53,19.18c0,10.98,8.2,18.97,19.53,18.97 c11.4,0,19.6-7.99,19.6-18.97S416.16,246.23,405.04,246.23z M405.04,275.9c-5.7,0-9.94-4.31-9.94-10.49c0-6.25,4.17-10.7,9.94-10.7 c5.77,0,10.01,4.52,10.01,10.7C415.05,271.59,410.81,275.9,405.04,275.9z M448.13,264.92l12.23-17.79h-10.77l-6.81,11.05 l-6.81-11.05H425.2l12.23,17.79l-12.79,18.56H435l7.78-11.4l7.71,11.4h10.42L448.13,264.92z M246.19,232.88 c-3.13,0-5.56,2.36-5.56,5.49c0,3.13,2.43,5.49,5.56,5.49c3.2,0,5.63-2.36,5.63-5.49C251.82,235.25,249.38,232.88,246.19,232.88z M326.8,250.95c-1.04-1.39-4.73-4.73-10.84-4.73c-10.35,0-17.72,7.92-17.72,19.11c0,11.19,6.88,19.04,17.37,19.04 c6.32,0,9.87-3.61,10.63-4.66v1.67c0,5.63-4.8,7.23-10.01,7.23c-5,0-9.17-1.88-10.35-2.5l-2.92,7.37 c3.27,1.81,8.34,3.34,13.34,3.34c10.7,0,19.53-4.38,19.53-17.93v-31.76h-9.03V250.95z M317.21,275.9c-5.42,0-9.31-4.24-9.31-10.63 s3.82-10.56,9.24-10.56c5.63,0,9.38,4.38,9.38,10.56C326.52,271.73,322.77,275.9,317.21,275.9z M279.82,246.23 c-4.73,0-8.2,2.64-9.73,5.14v-4.24h-9.38v36.35h9.59v-21.82c0-3.89,2.5-6.81,6.46-6.81c3.27,0,6.05,2.5,6.05,6.53v22.1h9.59v-20.99 C292.4,254.77,290.18,246.23,279.82,246.23z M328.33,202.09c1.33-0.97,1.62-3.12,1.75-4.95c0.13-1.83,0.52-7.32,0.65-10.59 c0.13-3.27,0.26-12.03-2.72-18.69c-2.76-6.16-9.83-11.74-16.73-13.75c6.89-2.01,13.97-7.58,16.73-13.75 c2.98-6.67,2.85-15.43,2.72-18.69c-0.13-3.27-0.52-8.76-0.65-10.59c-0.13-1.83-0.42-3.98-1.75-4.95c-0.76-0.56-2.95-1.7-19.15,3.82 c-12.97,4.42-16.83,14.07-17.83,17.96c-0.48,1.85-0.48,5.28-0.48,6.16v19.48c0,0.02,0,0.05,0,0.07c0,0.02,0,0.05,0,0.07v21.08 c0,1.68,0.2,4.17,0.7,6.25c1.06,3.87,4.64,12.83,17.61,17.24C325.39,203.79,327.57,202.65,328.33,202.09z M272.24,181.03 c0.5-2.07,0.7-4.57,0.7-6.25V153.7c0-0.02,0-0.05,0-0.07c0-0.02,0-0.05,0-0.07v-19.48c0-0.89,0-4.32-0.48-6.16 c-1-3.88-4.86-13.54-17.83-17.96c-16.21-5.52-18.39-4.38-19.15-3.82c-1.33,0.97-1.62,3.12-1.75,4.95 c-0.13,1.83-0.52,7.32-0.65,10.59s-0.26,12.03,2.72,18.69c2.76,6.16,9.83,11.74,16.73,13.75c-6.89,2.01-13.97,7.58-16.73,13.75 c-2.98,6.67-2.85,15.42-2.72,18.69s0.52,8.76,0.65,10.59s0.42,3.98,1.75,4.95c0.76,0.56,2.95,1.7,19.15-3.82 C267.6,193.85,271.19,184.9,272.24,181.03z"
    })), /*#__PURE__*/ React.createElement("g", {
        className: specsClassName
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("polyline", {
        points: "102.24,40.36 102.24,37.36 99.24,37.36",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "93.41",
        y1: "37.36",
        x2: "38.05",
        y2: "37.36",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "35.13,37.36 32.13,37.36 32.13,40.36",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "32.13",
        y1: "45.93",
        x2: "32.13",
        y2: "98.89",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "32.13,101.68 32.13,104.68 35.13,104.68",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "40.96",
        y1: "104.68",
        x2: "96.32",
        y2: "104.68",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "99.24,104.68 102.24,104.68 102.24,101.68",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "102.24",
        y1: "96.1",
        x2: "102.24",
        y2: "43.14",
        vectorEffect: "non-scaling-stroke"
    }))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("polyline", {
        points: "102.24,301.36 102.24,298.36 99.24,298.36",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "93.41",
        y1: "298.36",
        x2: "38.05",
        y2: "298.36",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "35.13,298.36 32.13,298.36 32.13,301.36",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "32.13",
        y1: "306.93",
        x2: "32.13",
        y2: "359.89",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "32.13,362.68 32.13,365.68 35.13,365.68",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "40.96",
        y1: "365.68",
        x2: "96.32",
        y2: "365.68",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "99.24,365.68 102.24,365.68 102.24,362.68",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "102.24",
        y1: "357.1",
        x2: "102.24",
        y2: "304.14",
        vectorEffect: "non-scaling-stroke"
    }))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("polyline", {
        points: "527.13,40.65 527.13,37.65 524.13,37.65",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "518.62",
        y1: "37.65",
        x2: "466.29",
        y2: "37.65",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "463.54,37.65 460.54,37.65 460.54,40.65",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "460.54",
        y1: "46.19",
        x2: "460.54",
        y2: "98.9",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "460.54,101.68 460.54,104.68 463.54,104.68",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "469.04",
        y1: "104.68",
        x2: "521.38",
        y2: "104.68",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "524.13,104.68 527.13,104.68 527.13,101.68",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "527.13",
        y1: "96.13",
        x2: "527.13",
        y2: "43.42",
        vectorEffect: "non-scaling-stroke"
    }))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("polyline", {
        points: "527.13,300.22 527.13,297.22 524.13,297.22",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "518.62",
        y1: "297.22",
        x2: "466.29",
        y2: "297.22",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "463.54,297.22 460.54,297.22 460.54,300.22\t",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "460.54",
        y1: "305.76",
        x2: "460.54",
        y2: "358.47",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "460.54,361.25 460.54,364.25 463.54,364.25",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "469.04",
        y1: "364.25",
        x2: "521.38",
        y2: "364.25",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "524.13,364.25 527.13,364.25 527.13,361.25",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "527.13",
        y1: "355.7",
        x2: "527.13",
        y2: "302.99",
        vectorEffect: "non-scaling-stroke"
    })), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("line", {
        x1: "102.15",
        y1: "37.97",
        x2: "102.15",
        y2: "34.97",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "102.15",
        y1: "30.05",
        x2: "102.15",
        y2: "12.84",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "102.15",
        y1: "10.38",
        x2: "102.15",
        y2: "7.38",
        vectorEffect: "non-scaling-stroke"
    })), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("line", {
        x1: "33.09",
        y1: "104.32",
        x2: "30.09",
        y2: "104.32",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "23.04",
        y1: "104.32",
        x2: "12.46",
        y2: "104.32",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "8.93",
        y1: "104.32",
        x2: "5.93",
        y2: "104.32",
        vectorEffect: "non-scaling-stroke"
    })))), /*#__PURE__*/ React.createElement("g", {
        className: specMarkersClassName
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M47.28,40.38c-11.37-3.87-12.9-3.07-13.43-2.68c-0.93,0.68-1.14,2.19-1.23,3.47s-0.36,5.13-0.45,7.43 c-0.09,2.29-0.18,8.44,1.91,13.11c1.93,4.32,6.9,8.24,11.73,9.64c-4.83,1.41-9.8,5.32-11.73,9.64c-2.09,4.68-2,10.82-1.91,13.11 c0.09,2.29,0.36,6.14,0.45,7.43s0.29,2.79,1.23,3.47c0.53,0.39,2.07,1.19,13.43-2.68c9.1-3.1,11.61-9.38,12.35-12.1 c0.35-1.45,0.49-3.2,0.49-4.38V71.07c0-0.02,0-0.03,0-0.05c0-0.02,0-0.03,0-0.05V57.3c0-0.62,0-3.03-0.34-4.32 C59.09,50.25,56.38,43.48,47.28,40.38z M87.02,71.36c4.83-1.41,9.8-5.32,11.73-9.64c2.09-4.68,2-10.82,1.91-13.11 c-0.09-2.29-0.36-6.14-0.45-7.43c-0.09-1.28-0.29-2.79-1.23-3.47c-0.53-0.39-2.07-1.19-13.43,2.68c-9.1,3.1-11.8,9.87-12.51,12.59 c-0.34,1.3-0.34,3.7-0.34,4.32v13.66c0,0.02,0,0.03,0,0.05c0,0.02,0,0.03,0,0.05v14.79c0,1.18,0.14,2.93,0.49,4.38 c0.74,2.71,3.26,9,12.35,12.1c11.37,3.87,12.9,3.07,13.43,2.68c0.93-0.68,1.14-2.19,1.23-3.47c0.09-1.28,0.36-5.13,0.45-7.43 c0.09-2.29,0.18-8.44-1.91-13.11C96.82,76.68,91.85,72.76,87.02,71.36z M64.3,19.02c-1.01,0-1.65,0.39-2.09,0.92l0.24-3.07h4.3 l0.04-1.12h-5.38l-0.35,5.22l1.09,0.11c0.41-0.59,1.04-1.01,1.93-1.01c1.2,0,1.99,0.71,1.99,1.99c0,1.4-0.92,2.17-2.1,2.17 c-1.23,0-1.83-0.69-1.98-1.72h-1.22c0.08,1.55,1.09,2.79,3.19,2.79c1.99,0,3.36-1.27,3.36-3.26C67.34,20.14,66.07,19.02,64.3,19.02 z M77.15,15.73l-6.09,9.41h1.01l6.08-9.41H77.15z M75.63,22.46c0,1.7,0.88,2.83,2.23,2.83s2.23-1.13,2.23-2.83 c0-1.6-0.88-2.68-2.23-2.68S75.63,20.86,75.63,22.46z M79.1,22.47c0,1.15-0.5,1.91-1.25,1.91c-0.76,0-1.25-0.76-1.25-1.91 c0-1.09,0.49-1.79,1.25-1.79C78.6,20.68,79.1,21.38,79.1,22.47z M73.5,18.3c0-1.6-0.88-2.68-2.23-2.68c-1.36,0-2.23,1.08-2.23,2.68 c0,1.7,0.87,2.83,2.23,2.83C72.62,21.12,73.5,19.99,73.5,18.3z M70.02,18.31c0-1.09,0.49-1.79,1.25-1.79c0.74,0,1.25,0.7,1.25,1.79 c0,1.15-0.5,1.91-1.25,1.91C70.51,20.21,70.02,19.46,70.02,18.31z M54.79,25.14H56c-0.01-3.46,1.32-5.84,3.24-8.33v-1.05h-6.49 v1.12h5.04C56.01,19.26,54.78,21.85,54.79,25.14z"
    })), /*#__PURE__*/ React.createElement("g", {
        className: specMarkersClassName
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M102.15,7.78c-1.04,1.04-3.11,1.54-4.54,1.58c1.92-1.43,3.6-3.29,4.54-5.55c0.9,2.25,2.68,4.03,4.54,5.55 C105.16,9.25,103.3,8.87,102.15,7.78z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.33,104.32c1.04,1.04,1.54,3.11,1.58,4.54c-1.43-1.92-3.29-3.6-5.55-4.54c2.25-0.9,4.03-2.68,5.55-4.54 C7.79,101.31,7.42,103.17,6.33,104.32z"
    })));
};
export default PrimaryLogoClearanceSVG;
